var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.18 0.599731H24.0996C22.5424 0.599731 21.2795 1.86219 21.2795 3.41974V23.1598C21.2795 24.7174 22.5424 25.9798 24.0996 25.9798H26.9196V30.68C26.9164 31.4011 27.3287 32.0597 27.9791 32.3717C28.2305 32.4952 28.5067 32.5594 28.7868 32.5598C29.2329 32.5543 29.6637 32.3965 30.0087 32.1132L36.6394 25.9799H54.1799C55.7374 25.9799 56.9999 24.7174 56.9999 23.1599V3.4198C56.9999 1.86225 55.7374 0.599792 54.1799 0.599792L54.18 0.599731ZM55.1199 23.1598C55.1199 23.6791 54.6993 24.0997 54.18 24.0997H36.6395C36.1958 24.1001 35.7666 24.2586 35.429 24.5462L28.7999 30.68V25.9798C28.7999 24.9415 27.9584 24.0997 26.9198 24.0997H24.0998C23.5808 24.0997 23.1599 23.6791 23.1599 23.1598V3.4197C23.1599 2.9004 23.5808 2.47983 24.0998 2.47983H54.1802C54.6995 2.47983 55.1201 2.9004 55.1201 3.4197L55.1199 23.1598Z",
    fill: "url(#paint0_linear_130_359)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8459 34.741C54.0858 34.5227 53.2699 34.6175 52.5802 35.0042L51.0585 35.8643L51.0097 35.8155C49.7134 34.5286 47.7916 34.1045 46.0747 34.7268L38.4022 37.6275L20.3541 34.5455C18.7745 34.2956 17.1573 34.4506 15.654 34.9963L11.8122 36.6546C11.5282 35.3622 10.3833 34.4409 9.05989 34.4401H3.41987C1.86231 34.4401 0.599854 35.7025 0.599854 37.2601V50.4205C0.599854 51.9776 1.86231 53.2405 3.41987 53.2405H9.05989C10.5423 53.2342 11.7666 52.0811 11.8622 50.6019C12.0526 50.5964 12.243 50.6211 12.426 50.6762L31.5728 56.8009C33.0352 57.2376 34.6182 56.9409 35.8233 56.0038L55.8716 39.9338C56.5817 39.3665 56.9963 38.5081 56.9995 37.5988C56.9963 37.0933 56.8673 36.5964 56.6234 36.153C56.2417 35.465 55.6016 34.9571 54.8451 34.7414L54.8459 34.741ZM32.9364 45.6182L30.0731 43.8404H36.9445L33.824 45.6041C33.549 45.7568 33.2161 45.7623 32.9364 45.6183L32.9364 45.6182ZM46.7282 36.4898C47.5997 36.175 48.5698 36.3076 49.3248 36.8442L42.7445 40.5636C42.7232 40.372 42.6831 40.1832 42.6245 39.9998C42.6076 39.9452 42.5859 39.8924 42.5659 39.8389C42.5191 39.7099 42.4628 39.584 42.3979 39.4628C42.3695 39.4101 42.3424 39.3586 42.3101 39.3078C42.2287 39.1752 42.1366 39.0497 42.0347 38.9317C42.0131 38.9073 41.9962 38.879 41.9738 38.8558C41.8463 38.7173 41.7058 38.5914 41.5544 38.4797C41.5434 38.4722 41.5347 38.4608 41.5237 38.4525L46.7282 36.4898ZM10.0006 50.4206C10.0006 50.9395 9.58004 51.3605 9.06073 51.3605H3.42071C2.90141 51.3605 2.48084 50.9395 2.48084 50.4206V37.2602C2.48084 36.7409 2.90141 36.3203 3.42071 36.3203H9.06073C9.58004 36.3203 10.0006 36.7409 10.0006 37.2602V37.9971C10.0006 38.0187 9.99116 38.0384 9.99116 38.06L10.0006 49.8296V50.4206ZM54.7018 38.4628L34.6626 54.5288C33.9442 55.0831 33.004 55.2605 32.133 55.0064L12.9972 48.8848C12.6435 48.7751 12.2756 48.7192 11.9058 48.7196H11.8803V38.671L16.3435 36.7421C17.5305 36.318 18.8055 36.1996 20.0507 36.3983L38.3244 39.5188C38.3461 39.5227 38.3681 39.5259 38.3901 39.5275L39.9571 39.7934C40.4843 39.8803 40.873 40.3336 40.8793 40.8678C40.8821 41.1538 40.7707 41.4292 40.5701 41.633C40.3631 41.8408 40.0822 41.9588 39.7888 41.9611H23.0198C22.5004 41.9611 22.0795 42.3817 22.0795 42.901C22.0795 43.4203 22.5004 43.8409 23.0198 43.8409H26.5109L31.9818 47.238C32.1946 47.3572 32.4224 47.4489 32.6584 47.5106C32.802 47.5413 32.948 47.5602 33.0943 47.5673C33.1844 47.5834 33.2749 47.5948 33.3662 47.6019H33.3709C33.5609 47.5968 33.7498 47.5732 33.9351 47.5303C33.9799 47.5212 34.0287 47.524 34.0732 47.5126C34.3076 47.452 34.5335 47.3615 34.7451 47.2439L51.361 37.8542L51.3665 37.8495L53.4997 36.6433C54.0245 36.3525 54.6858 36.5394 54.9809 37.0615C55.0714 37.2267 55.1198 37.4112 55.1209 37.5993C55.1202 37.936 54.9659 38.2539 54.702 38.4632L54.7018 38.4628Z",
    fill: "url(#paint1_linear_130_359)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7753 14.4248C34.1439 14.7809 34.7305 14.7758 35.0928 14.4134C35.4556 14.0507 35.4607 13.4645 35.1042 13.0955L32.0089 10.0001L35.1042 6.90475C35.3485 6.66869 35.4465 6.31934 35.3607 5.99084C35.2746 5.66195 35.0181 5.40544 34.6892 5.31928C34.3607 5.23351 34.0113 5.33147 33.7753 5.57579L30.015 9.33567C29.6483 9.70273 29.6483 10.298 30.015 10.665L33.7753 14.4248Z",
    fill: "url(#paint2_linear_130_359)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1752 14.4248C43.5423 14.7919 44.1375 14.7919 44.5046 14.4248L48.2644 10.6649C48.6315 10.2979 48.6315 9.70264 48.2644 9.33561L44.5046 5.57573C44.1355 5.21929 43.5493 5.2244 43.1866 5.58714C42.8243 5.94948 42.8192 6.53606 43.1752 6.90469L46.2706 10.0001L43.1752 13.0954C42.8081 13.4625 42.8081 14.0577 43.1752 14.4248L43.1752 14.4248Z",
    fill: "url(#paint3_linear_130_359)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9722 14.6716C38.0466 14.6905 38.1229 14.7003 38.1996 14.6999C38.6304 14.6995 39.0061 14.406 39.1108 13.9882L40.9905 6.46846C41.1125 5.96645 40.8068 5.4601 40.3056 5.33461C39.8047 5.20911 39.2961 5.51125 39.167 6.01129L37.2868 13.5315C37.2262 13.7734 37.2648 14.0299 37.3931 14.2435C37.5217 14.4576 37.7302 14.6114 37.9722 14.6716L37.9722 14.6716Z",
    fill: "url(#paint4_linear_130_359)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4204 16.5801H48.5402C48.0209 16.5801 47.6003 17.0007 47.6003 17.52C47.6003 18.0393 48.0209 18.4598 48.5402 18.4598H50.4204C50.9393 18.4598 51.3602 18.0393 51.3602 17.52C51.3602 17.0007 50.9393 16.5801 50.4204 16.5801Z",
    fill: "url(#paint5_linear_130_359)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8604 18.4595H43.8398C44.3591 18.4595 44.7801 18.0389 44.7801 17.5196C44.7801 17.0003 44.3591 16.5797 43.8398 16.5797H27.8604C27.3411 16.5797 26.9202 17.0003 26.9202 17.5196C26.9202 18.0389 27.3411 18.4595 27.8604 18.4595Z",
    fill: "url(#paint6_linear_130_359)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4204 20.3398H49.4802C48.9612 20.3398 48.5403 20.7608 48.5403 21.2797C48.5403 21.799 48.9612 22.2199 49.4802 22.2199H50.4204C50.9393 22.2199 51.3603 21.799 51.3603 21.2797C51.3603 20.7608 50.9393 20.3398 50.4204 20.3398Z",
    fill: "url(#paint7_linear_130_359)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7202 20.3398H34.4401C33.9208 20.3398 33.5002 20.7608 33.5002 21.2797C33.5002 21.799 33.9208 22.2199 34.4401 22.2199H45.7202C46.2395 22.2199 46.66 21.799 46.66 21.2797C46.66 20.7608 46.2395 20.3398 45.7202 20.3398Z",
    fill: "url(#paint8_linear_130_359)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6804 20.3398H27.8604C27.3411 20.3398 26.9202 20.7608 26.9202 21.2797C26.9202 21.799 27.3411 22.2199 27.8604 22.2199H30.6804C31.1994 22.2199 31.6203 21.799 31.6203 21.2797C31.6203 20.7608 31.1994 20.3398 30.6804 20.3398Z",
    fill: "url(#paint9_linear_130_359)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17962 38.1996H5.29988C4.78058 38.1996 4.35962 38.6205 4.35962 39.1398C4.35962 39.6587 4.78058 40.0797 5.29988 40.0797H7.17962C7.69893 40.0797 8.11988 39.6587 8.11988 39.1398C8.11988 38.6205 7.69893 38.1996 7.17962 38.1996Z",
    fill: "url(#paint10_linear_130_359)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17962 47.6003H5.29988C4.78058 47.6003 4.35962 48.0208 4.35962 48.5402C4.35962 49.0595 4.78058 49.48 5.29988 49.48H7.17962C7.69893 49.48 8.11988 49.0595 8.11988 48.5402C8.11988 48.0208 7.69893 47.6003 7.17962 47.6003Z",
    fill: "url(#paint11_linear_130_359)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_130_359",
    x1: 39.1397,
    y1: 0.599731,
    x2: 39.1397,
    y2: 32.5598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_130_359",
    x1: 28.7997,
    y1: 34.4294,
    x2: 28.7997,
    y2: 56.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_130_359",
    x1: 32.5656,
    y1: 5.28876,
    x2: 32.5656,
    y2: 14.6886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_130_359",
    x1: 45.7198,
    y1: 5.31171,
    x2: 45.7198,
    y2: 14.7001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_130_359",
    x1: 39.138,
    y1: 5.30621,
    x2: 39.138,
    y2: 14.6999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_130_359",
    x1: 49.4803,
    y1: 16.5801,
    x2: 49.4803,
    y2: 18.4598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_130_359",
    x1: 35.8501,
    y1: 16.5797,
    x2: 35.8501,
    y2: 18.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_130_359",
    x1: 49.9503,
    y1: 20.3398,
    x2: 49.9503,
    y2: 22.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_130_359",
    x1: 40.0801,
    y1: 20.3398,
    x2: 40.0801,
    y2: 22.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_130_359",
    x1: 29.2702,
    y1: 20.3398,
    x2: 29.2702,
    y2: 22.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_130_359",
    x1: 6.23975,
    y1: 38.1996,
    x2: 6.23975,
    y2: 40.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_130_359",
    x1: 6.23975,
    y1: 47.6003,
    x2: 6.23975,
    y2: 49.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E17EB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon1);
export default __webpack_public_path__ + "static/media/service-icon1.08bc8422f4fd4ed1b416f508526ca523.svg";
export { ForwardRef as ReactComponent };